import { FromURL } from "../types";

export function useOrigin(): FromURL {
  const origin = (() => {
    const originUrl = document.location.origin;
    const clientURl = new URL(originUrl);
    const subdomain = clientURl.hostname.split(".")[0];
    if (!["pass", "newpass", "app"].includes(subdomain)) {
      return subdomain;
    }
    return sessionStorage.getItem("origin");
  })();

  if (!origin) {
    return FromURL.None;
  }
  return FromURL.Partner;
}
